<template>
<v-app-bar :app="app" color="teal lighten-2" dark >
  <v-app-bar-nav-icon v-if="withSidebar" @click="$emit('sidebar')" ></v-app-bar-nav-icon>
  <v-toolbar-title >{{title}}</v-toolbar-title>

  <v-chip x-small label
    v-if="appName"
    class="ml-2" >
    <v-icon v-if="appIcon" left x-small >{{appIcon}}</v-icon>
    {{appName}}</v-chip>
  <slot ></slot>
  <v-spacer/>
  <v-menu>
    <template v-slot:activator="{ on }">
      <v-btn v-on='on' slot='activator' small icon class="mr-3" >
        <v-icon >mdi-apps</v-icon>
      </v-btn>
    </template>
    <v-card flat width="500" >
      <tg-app-registry />
    </v-card>
  </v-menu>
</v-app-bar>
</template>

<script>
import TgAppRegistry from '@/components/ui/TgAppRegistry.vue'

export default {
  name: 'TgAppBar',
  components: {TgAppRegistry},
  props:{
    app: { type: Boolean, default: true },
    title: { type: String, default: 'RISEAPP' },
    appName: { type: String, required: false },
    appIcon: { type: String, required: false },
    withSidebar: { type: Boolean, default: true }
  }
}
</script>

<style>

</style>